<ng-container *ngIf="{ rtlDir: rtlDir$ | async } as vm">
  <p-drawer
    #sidebar
    [(visible)]="configActive"
    [position]="vm.rtlDir ? 'left' : 'right'"
    [blockScroll]="true"
    [baseZIndex]="1000"
    styleClass="layout-config !p-0 !w-[30rem] app-osos-ai"
    [modal]="false"
    [showCloseIcon]="false"
    (onHide)="configActiveChange.emit(false)"
  >
    <ng-container [ngTemplateOutlet]="sidebarTpl"></ng-container>
  </p-drawer>
  <ng-template #sidebarTpl>
    <iframe
      [src]="aiUrl | safe: 'resourceUrl'"
      frameborder="0"
      class="w-100 h-full osos-ai"
    ></iframe>
  </ng-template>
</ng-container>
